/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'eye': {
    width: 14,
    height: 10,
    viewBox: '0 0 14 10',
    data: '<path pid="0" d="M7 3.35A1.775 1.775 0 0 1 8.75 5.1 1.775 1.775 0 0 1 7 6.85 1.775 1.775 0 0 1 5.25 5.1 1.775 1.775 0 0 1 7 3.35zm0 4.676c.532 0 1.022-.13 1.47-.392A2.908 2.908 0 0 0 9.534 6.57c.261-.448.392-.938.392-1.47s-.13-1.022-.392-1.47A2.908 2.908 0 0 0 8.47 2.566 2.865 2.865 0 0 0 7 2.174c-.532 0-1.022.13-1.47.392A2.908 2.908 0 0 0 4.466 3.63a2.865 2.865 0 0 0-.392 1.47c0 .532.13 1.022.392 1.47.261.448.616.803 1.064 1.064.448.261.938.392 1.47.392zM7 .718a6.827 6.827 0 0 1 4.963 2.1A6.85 6.85 0 0 1 13.426 5.1a6.774 6.774 0 0 1-1.463 2.275A6.872 6.872 0 0 1 7 9.468 6.872 6.872 0 0 1 .574 5.1a6.85 6.85 0 0 1 1.463-2.282A6.827 6.827 0 0 1 7 .718z" _fill="#2E3059" fill-rule="evenodd" opacity=".8"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/eye.js